<template>
  <div class="form-area">
    <div class="form-title">
      【注 意 事 項 Precaution】<br />
      請檢查上傳檔案及其內容是否齊全， 僅⽀援PDF、PNG、JPG、JPEG、DOC 及 DOCX檔案格式，請上傳少於5MB的檔案。 <br />
      Please check if the uploaded documents and their contents are complete,
      only PDF,PNG,JPG,JPEG,DOC and DOCX file<br />
      formats are supported, please upload file of less than 5MB.
    </div>

    <!-- 当前前頁面為第一位用戶填寫 -->
    <div class="form-title" v-if="currentOperateName === 'fileIndex'">
      請上傳閣下的證明⽂件及相關聲明書<br />
      Please upload your documents and relevant declarations
    </div>

    <!-- 当前前頁面為第二位用戶填寫 -->
    <div class="form-title" v-if="currentOperateName === 'fileIndex2'">
      請上傳第⼆位申請⼈的證明⽂件及相關聲明書<br />
      Please upload second applicant's documents and relevant declarations
    </div>

    <ul class="important-note-content">
      <el-form :model="fileUploadForm" :rules="fileUploadFormRules" ref="fileUploadForm">
        <li class="form-label upload-label">
          個人資料<br />Personal Information
          <div class="upload-title">
            1.1身份證副本 Hong Kong Identity Card（*必須遞交）
          </div>
          <div class="upload-area">
            <el-form-item prop="identityCardFiles"
              :rules="[{ required: true,message:'請上傳身份證副本 Hong Kong Identity Card', trigger: 'blur' }]">
              <file-upload :limit="3" :files="fileUploadForm.identityCardFiles" uploadName="identityCardFiles"
                fileLabel="身份證副本" @handFileUpload="handFileUploadEvent"></file-upload>
            </el-form-item>
          </div>
          <div class="upload-title">
            1.2 申請人居住地址證明 Proof of Resident Address（*必須遞交）
          </div>
          <div class="upload-area">
            <el-form-item prop="residentAddressFiles"
              :rules="[{ required: true,message:'請上傳申請人居住地址證明 Proof of Resident Address', trigger: 'blur' }]">
              <file-upload :limit="3" :files="fileUploadForm.residentAddressFiles" uploadName="residentAddressFiles"
                fileLabel="申請人居住地址證明" @handFileUpload="handFileUploadEvent"></file-upload>
            </el-form-item>
            <div class="upload-tip">
              須遞交發出的最近 3 個月的居住地址證明<br />
              Please provide for the last 3 months proof of resident address valid supporting document
            </div>
          </div>
        </li>

        <li class="form-label upload-label">
          主要收入申報 (請選擇適用的表格填寫，並上傳有關文件)<br />
          Income (Please select the applicable form to fill in and upload the
          relevant documents)
          <div class="upload-area">
            <el-form-item>
              <el-checkbox-group v-model="fileUploadForm.incomeCheckList">
                <div v-for="item in incomeList" :key="item.key">
                  <div class="upload-form-checkbox">
                    <el-checkbox :label="item.key"><span style="color: #000000">{{ item.content }}</span>
                    </el-checkbox>
                  </div>
                  <form-template :ref="item.key" :formName="item.key" @handlerSumbit="handlerChildSumbit"
                    @handlerValid="handlerChildValid" v-if="fileUploadForm.incomeCheckList.includes(item.key)"
                    :fieldList="item.formDataFields" />
                </div>
              </el-checkbox-group>
            </el-form-item>
          </div>
        </li>

        <li class="form-label upload-label">
          資產申報 (請選擇適用的表格填寫，並上傳有關文件)<br />Asset value
          declaration (Please select the applicable form to fill in and upload
          the relevant documents)

          <div class="upload-area">
            <el-form-item>
              <el-checkbox-group v-model="fileUploadForm.assetCheckList">
                <div v-for="item in assetList" :key="item.key">
                  <div class="upload-form-checkbox">
                    <el-checkbox :label="item.key"><span style="color: #000000">{{ item.content }}</span>
                    </el-checkbox>
                  </div>
                  <form-template :ref="item.key" :formName="item.key"
                    v-if="fileUploadForm.assetCheckList.includes(item.key)" @handlerSumbit="handlerChildSumbit"
                    @handlerValid="handlerChildValid" :fieldList="item.formDataFields" />
                </div>
              </el-checkbox-group>
            </el-form-item>
          </div>
        </li>
      </el-form>
    </ul>

    <el-row class="btn-box">
      <el-col :span="12">
        <el-button type="warning" class="two-btn" round @click="previousSetp()">上一步 Back</el-button>
      </el-col>
      <el-col :span="12">
        <el-button type="warning" class="two-btn" round @click="saveAndNextSetp()">繼續 Next</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import FormTemplate from "./child/formTemplate.vue";
  import {
    filterIncomeData,
    filterAssetData,
    filterFormFieldsData,
  } from "@/utils/json/utils";
  import {
    fileUploadForm
  } from "@/assets/js/api.js";
  import FileUpload from "@/components/FileUpload";
  export default {
    components: {
      FormTemplate,
      FileUpload,
    },
    watch: {
      'fileUploadForm.identityCardFiles'() { //校验文件是否上传->身份证上传资料
        if (this.fileUploadForm.identityCardFiles.length > 0) {
          this.$refs.fileUploadForm.clearValidate("identityCardFiles");
        }
      },
      'fileUploadForm.residentAddressFiles'() { //校验文件是否上传-> 申请人居住地址证明
        if (this.fileUploadForm.residentAddressFiles.length > 0) {
          this.$refs.fileUploadForm.clearValidate("residentAddressFiles");
        }
      }
    },
    created() {
      this.fillIncomeData();
      this.fillAssetData();
    },
    mounted() {
      //回显数据
      this.initFormData();
    },
    data() {
      return {
        //判斷是單人申請還是雙人
        isSingle: this.Session.get("formId") === 1,
        //判斷當前是第一人還是第二人
        currentOperateName: this.$store.getters.querySetepInfo.currentOperateName,
        fileUploadForm: {
          incomeCheckList: [], //主要收入申报勾选组
          assetCheckList: [], //資產申報勾选组
          identityCardFiles: [], //身份证上传资料
          residentAddressFiles: [], //申请人居住地址证明
          childrenFormData: {}, //子表单集合
        },
        childFormValid: true,
        //主表單校驗規則
        fileUploadFormRules: {
          incomeCheckList: [{
            type: "array",
            required: true,
            message: "請至少選擇一項主要收入申報",
            trigger: "change",
          }, ],
          assetCheckList: [{
            type: "array",
            required: true,
            message: "請至少選擇一項資產申報",
            trigger: "change",
          }, ],
        },
        incomeList: filterFormFieldsData("incomeList"), //加载2.*checkbox選項列表
        assetList: filterFormFieldsData("assetList"), //加载3.*checkbox選項列表
      };
    },
    methods: {
      initFormData() {
        if ("fileIndex" === this.currentOperateName) {
          this.loadFirstUploadInfo();
        }
        if ("fileIndex2" === this.currentOperateName) {
          this.loadSecondUploadInfo();
        }
        this.setChildrenFormData(this.fileUploadForm.incomeCheckList);
        this.setChildrenFormData(this.fileUploadForm.assetCheckList);
      },
      //上一步
      previousSetp() {
        //去除多餘的子表單
        this.removeUselessFormItem();
        //拼装文件list
        this.assembleFileList();
        if ("fileIndex" === this.currentOperateName) {
          //单人申请返回声明
          this.$store.dispatch("PREVIOUS_SETP", {
            changeStep: true,
            operateName: "informationPreview",
          });
        }
        if ("fileIndex2" === this.currentOperateName) {
          //二人申请返回一人申请
          this.$store.dispatch("PREVIOUS_SETP", {
            changeStep: false,
            operateName: "fileIndex",
          });
        }
      },

      /**
       *加载子表单2.*收入情况表格formData属性
       */
      fillIncomeData() {
        for (var i = 0; i < this.incomeList.length; i++) {
          var income = this.incomeList[i];
          income.formDataFields = filterIncomeData(income.key);
        }
      },
      /**
       * 加载子表单3.*资产申报表格formData属性
       */
      fillAssetData() {
        for (var i = 0; i < this.assetList.length; i++) {
          var asset = this.assetList[i];
          asset.formDataFields = filterAssetData(asset.key);
        }
      },

      loadFirstUploadInfo() {
        this.fileUploadForm =
          this.Session.get("fileUploadForm") || this.fileUploadForm;
      },
      //第二個用戶總是load緩存
      loadSecondUploadInfo() {
        this.fileUploadForm =
          this.Session.get("fileUploadForm2") || this.fileUploadForm;
      },

      /**
       * 获取子表单的校验
       */
      getChildrenFormValidata(arr) {
        for (var i = 0; i < arr.length; i++) {
          this.$refs[arr[i]][0].getChildrenFormValidata();
        }
      },
      /**
       * 子表单提交数据
       */
      handlerChildSumbit(obj) {
        this.fileUploadForm.childrenFormData[obj.formName] = obj.formData;
      },
      /**
       * 子组件表单验证返回
       */
      handlerChildValid(valid) {
        if (!valid) {
          //只要有一个不通过，即不可提交
          this.childFormValid = false;
        }
      },
      /**
       * 上传组件 上传成功回传列表
       */
      handFileUploadEvent(data) {
        this.fileUploadForm[data.fieldName] = data.files;
      },
      //设置子表单form数据
      setChildrenFormData(arr) {
        this.$nextTick(() => {
          for (var i = 0; i < arr.length; i++) {
            //设置子组件的表格值
            this.$refs[arr[i]][0].formData =
              this.fileUploadForm.childrenFormData[arr[i]];
          }
        });
      },
      //保存並下一步操作
      saveAndNextSetp() {
        if ("fileIndex" === this.currentOperateName) {
          //判斷是一人還是二人申請
          if (this.isSingle) {
            //直接提交
            this.submit();
          } else {
            //二人申請先校驗第一人表单，然後跳轉到第二個人填寫資料界面
            this.$refs.fileUploadForm.validate((valid) => {
              if (valid) {
                this.childFormValid = true; //重置子表单校验
                this.getChildrenFormValidata(this.fileUploadForm.incomeCheckList);
                this.getChildrenFormValidata(this.fileUploadForm.assetCheckList);
                if (this.childFormValid) {
                  this.removeUselessFormItem();
                  //拼装文件list
                  this.assembleFileList();
                  //下一步操作
                  this.$store.dispatch("NEXT_STEP", {
                    changeStep: false,
                    operateName: "fileIndex2",
                  });
                  this.loadSecondUploadInfo();
                  console.log("fileIndex2 success submit!!");
                }
              } else {
                console.log("fileIndex2 error submit!!");
                this.validFail();
                return false;
              }
            });
          }
        }
        if ("fileIndex2" === this.currentOperateName) {
          this.submit();
        }
      },
      removeUselessFormItem() {
        //删除多余的表格,避免提交无用数据到后台
        var incomeCheckList = this.fileUploadForm.incomeCheckList;
        var assetCheckList = this.fileUploadForm.assetCheckList;
        const keys = Object.keys(this.fileUploadForm.childrenFormData);
        keys.forEach((key) => {
          if (!incomeCheckList.includes(key) && !assetCheckList.includes(key)) {
            delete this.fileUploadForm.childrenFormData[key];
          }
        });
        if ("fileIndex" === this.currentOperateName) {
          this.Session.set("fileUploadForm", this.fileUploadForm);
        }
        if ("fileIndex2" === this.currentOperateName) {
          this.Session.set("fileUploadForm2", this.fileUploadForm);
        }
      },
      /**
       * 整合所有上传文档到一个数组
       */
      assembleFileList() {
        const fileList = [];
        //身份证
        var identityCardFiles = this.fileUploadForm.identityCardFiles;
        //居住地址证明
        var residentAddressFiles = this.fileUploadForm.residentAddressFiles;
        //子表格
        var childrenFormDataKeys = Object.keys(this.fileUploadForm.childrenFormData);
        for (let i = 0; i < identityCardFiles.length; i++) {
          fileList.push(identityCardFiles[i]);
        }
        for (let i = 0; i < residentAddressFiles.length; i++) {
          fileList.push(residentAddressFiles[i]);
        }
        for (let i = 0; i < childrenFormDataKeys.length; i++) {
          let childFormData = this.fileUploadForm.childrenFormData[childrenFormDataKeys[i]];
          if (childFormData.uploadFiles) {
            let uploadFiles = childFormData.uploadFiles;
            if (uploadFiles.length > 0)
              for (let j = 0; j < uploadFiles.length; j++) {
                fileList.push(uploadFiles[j])
              }
          }
        }
        if ("fileIndex" === this.currentOperateName) {
          this.Session.set("fileList", fileList);
        }
        if ("fileIndex2" === this.currentOperateName) {
          this.Session.set("fileList2", fileList);
        }
      },
      //保存並下一步操作
      submit() {
        //驗證表單
        this.$refs.fileUploadForm.validate((valid) => {
          if (valid) {
            this.childFormValid = true; //重置子表单校验
            this.getChildrenFormValidata(this.fileUploadForm.incomeCheckList);
            this.getChildrenFormValidata(this.fileUploadForm.assetCheckList);
            if (this.childFormValid) {
              console.log("fileIndex success submit!!");
              this.removeUselessFormItem();
              //拼装文件list
              this.assembleFileList();
              //下一步操作,调用接口提交
              let params = {
                fileUpload: JSON.stringify({
                  fileUploadForm: this.Session.get("fileUploadForm"), //第一位申请人信息
                  fileUploadForm2: this.Session.get("fileUploadForm2"), //第二位申请人信息
                }),
                fileList: JSON.stringify({
                    fileList: this.Session.get("fileList"), //第一位申请人信息
                    fileList2: this.Session.get("fileList2"), //第二位申请人信息
                  }

                )
              };
              fileUploadForm(params).then((res) => {
                //提交数据
                this.$store.dispatch("NEXT_STEP", {
                  changeStep: true,
                  operateName: "terms",
                });
              });
            }
          } else {
            console.log("fileIndex error submit!!");
            this.validFail();
            return false;
          }
        });
      },
      // 校验未通过时的处理
      validFail() {
        setTimeout(() => {
          let isError = document.getElementsByClassName("is-error");
          isError[0].scrollIntoView({
            behavior: "smooth", // 平滑过渡
            block: 'center', //居中
          });;
        }, 100);
        this.$message.warning("請填寫紅色必填欄目");
      },
    },
  };

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/upload/index.vue